import React from 'react';
import { CHECKOUT_URL } from '../data/offer';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  note?: string;
};
export function CtaButton({
  children,
  size = 'md',
  className = '',
  note
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-base sm:px-10 sm:py-5 sm:text-xl' : 'px-6 py-4 text-sm sm:px-8 sm:text-lg';
  return <div className={`flex w-full flex-col items-center sm:w-auto ${className}`} data-id="element-64" data-mp="qi7ffposfo9v">
      <a href={CHECKOUT_URL} target="_top" rel="noopener" onClick={trackInitiateCheckout} className={`inline-flex w-full items-center justify-center rounded-full bg-mint text-center font-display uppercase leading-tight tracking-wide text-carbon-900 transition-colors duration-150 ease-out hover:bg-mint-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mint focus-visible:ring-offset-2 focus-visible:ring-offset-carbon-900 sm:w-auto ${sizing}`} data-id="element-65" data-mp="ll7bplfeuxlx">
        {children}
      </a>
      {note ? <p className="mt-3 text-center text-[11px] uppercase tracking-[0.16em] text-paper-dim sm:text-xs" data-id="element-66" data-mp="39xzmwewkcgyj">
          {note}
        </p> : null}
    </div>;
}